import React from "react";
// import ThreeDProperties from "../Shared/3DProperties";
import StyleProperties from "../Shared/StyleProperties";
import Coordinates from "../Shared/Coordinates";
import Details from "../Shared/Details";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { createOrUpdateShape } from "orion-components/GlobalData/Actions";
import { getTranslation } from "orion-components/i18n";
import MapDisplayOptions from "../Shared/MapDisplayOptions";

const LineStringEditor = () => {
	const { mapTools } = useSelector((state) => state.mapState);

	const dispatch = useDispatch();

	useEffect(() => {
		const { feature } = mapTools;
		if (feature) {
			const { properties } = feature;
			const { polyStroke, lineWidth, lineType, lineStrokeOpacity } = properties;
			dispatch(
				createOrUpdateShape("lineString", {
					polyStroke,
					lineWidth,
					lineType,
					lineStrokeOpacity: lineStrokeOpacity * 100
				})
			);
		}
	}, []);

	return (
		<div>
			<Details
				shapeName={getTranslation("global.sharedComponents.shapeEditor.components.lineStringEditor.lineName")}
				shapeType="lineString"
			/>
			{/* <ThreeDProperties /> */}
			<MapDisplayOptions shapeType="lineString" />
			<StyleProperties shapeType="lineString" />
			<Coordinates />
		</div>
	);
};
export default LineStringEditor;
